import BackgroundColor from "../ConfigParameters/BackgroundColor";
import BackgroundImage from "../ConfigParameters/BackgroundImage";

export default class Backgrounds {

    constructor() {
        return {
            ...(new BackgroundColor()),
            ...(new BackgroundImage()),
        };
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigCollections/Backgrounds.js